import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoMdiCloud = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 18H13.5V20H7C5.5 20 4.19 19.5 3.11 18.43C2.04 17.38 1.5 16.09 1.5 14.58C1.5 13.28 1.89 12.12 2.67 11.1C3.45 10.08 4.5 9.43 5.75 9.15C6.17 7.62 7 6.38 8.25 5.43C9.5 4.48 10.92 4 12.5 4C14.45 4 16.1 4.68 17.46 6.04C18.58 7.16 19.23 8.5 19.43 10C18.73 10 18.06 10.19 17.45 10.46C17.3517 9.32415 16.8518 8.26053 16.04 7.46C15.06 6.5 13.88 6 12.5 6C11.12 6 9.94 6.5 8.96 7.46C8 8.44 7.5 9.62 7.5 11H7C6.03 11 5.21 11.34 4.53 12.03C3.84 12.71 3.5 13.53 3.5 14.5C3.5 15.47 3.84 16.29 4.53 17C5.21 17.66 6.03 18 7 18ZM23.5 17.3V20.8C23.5 21.4 22.9 22 22.2 22H16.7C16.1 22 15.5 21.4 15.5 20.7V17.2C15.5 16.6 16.1 16 16.7 16V14.5C16.7 13.1 18.1 12 19.5 12C20.9 12 22.3 13.1 22.3 14.5V16C22.9 16 23.5 16.6 23.5 17.3ZM21 14.5C21 13.7 20.3 13.2 19.5 13.2C18.7 13.2 18 13.7 18 14.5V16H21V14.5Z",
		fill: "#7B61FF"
	})]
});
const ForwardRef = forwardRef(SvgLogoMdiCloud);
export { ForwardRef as ReactComponent };
